import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { AnimationTypes } from "@app/components/routing/AnimatedRoute/AnimatedRoute"
import ZoneInformationModal from "@app/modals/funnel/ZoneInformationModal/ZoneInformationModal"
import { setZone, setZoneId } from "@app/store/actions/coreActions"
import { useGetStrings, useGetZone, useGetZonePricePin } from "@app/store/service/cmsService"
import { useGetVisitorKinds } from "@app/store/service/connectorService"
import { appStore } from "@app/store/store"
import { classNamez, Image, useModal, useViewport } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useCallback, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { ZoneDetailInformation } from "../ZoneDetailInformation/ZoneDetailInformation"
import "./Zone.css"

export default function Zone(props) {
	const { data } = useGetZone(props.zoneId)

	const {
		data: { pricePin },
	} = useGetZonePricePin({ zoneId: props.zoneId }, { skip: !props.zoneId, defaultData: {} })
	const { image, title, subTitle, zoneId, subText } = data || {}
	const { data: stringData } = useGetStrings()
	const { buttonBookTicket, moreInformation, notAvailable } = stringData || {}
	const relation = useSelector("core.relation")
	const { sm, md, lg, xl } = useViewport()
	const { push } = useCustomNavigation()
	const { showModal } = useModal()
	const { data: visitorKindData, isLoading } = useGetVisitorKinds(
		{ zoneId: props.zoneId, locationId: appStore.get("core.locationId") },
		{ skip: !props.zoneId },
	)
	const [imageLoaded, setImageLoaded] = useState(false)

	const goToOrder = useCallback(() => {
		setZoneId(zoneId)
		setZone(data)

		if (!appStore.get("core.relation") && appStore.get("core.kioskMode") !== true) {
			push("/login", AnimationTypes.slide)
		} else {
			push("/order/person-types", AnimationTypes.slide)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data, relation])

	let disabled =
		appStore.get("core.htgGuestData") &&
		(isLoading ||
			(visitorKindData && !visitorKindData.length) ||
			(visitorKindData && visitorKindData.filter(e => new Date(e.firstAvailableDate).getMonth() - new Date().getMonth() >= 4).length))

	if (disabled) {
		return null
	}

	return (
		<div
			className={classNamez({ "container-sm": lg || xl }) + " zone mr-lg-4 mb-3 mb-lg-0 ml-0 rounded-2 text-left color-bg-default "}
			aria-labelledby={`zone-title-${zoneId}`}
			aria-describedby={`zone-desc-${zoneId}`}
			role="group"
		>
			{image ? (
				<Image
					src={image}
					asBackground
					className="zone__image rounded-top-2"
					onLoad={() => {
						setImageLoaded(true)
					}}
				/>
			) : (
				<Skeleton className="rounded-top-2" style={{ height: "200px" }} />
			)}

			{pricePin && <Image src={pricePin} className="absolute top-0 left-0" style={{ width: "80px" }} />}

			<div className="zone__info p-3 color-bg-default rounded-bottom-2">
				<div
					className={
						"zone__inImage " +
						classNamez({
							"color-fg-white": sm || md,
							"color-fg-primary": lg || xl,
							"zone__inImage--loaded": imageLoaded,
						})
					}
				>
					<div className={classNamez({ "text-wrapper": title || subTitle })}>
						<h3 id={`zone-title-${zoneId}`} className="f3 medium mb-2 f-second text-center bold" style={{ height: "20px" }}>
							{title ? title : <Skeleton />}
						</h3>
						{(sm || md) && (
							<p id={`zone-desc-${zoneId}`} className="text-center f4">
								{subText}
							</p>
						)}
					</div>
					{(lg || xl) && (
						<p id={`zone-desc-${zoneId}`} className="color-fg-secondary mb-4 text-center" style={{ height: "32px" }}>
							{subTitle ? subTitle : <Skeleton />}
						</p>
					)}
				</div>

				{(sm || md) && (
					<button
						className="focusable-text color-fg-secondary mt-1 mb-4 text-center"
						onClick={() => {
							showModal(ZoneInformationModal, { zoneId })
						}}
					>
						{moreInformation ? moreInformation : <Skeleton />}
					</button>
				)}

				<div className="flex">
					{buttonBookTicket ? (
						<Button style="primary" fillWidth onClick={goToOrder} disabled={disabled} disabledReason={disabled && notAvailable}>
							{buttonBookTicket}
						</Button>
					) : (
						<span className="f00 fill">
							<Skeleton />
						</span>
					)}
				</div>

				{(lg || xl) && (
					<div className="mt-4">
						<ZoneDetailInformation zoneId={zoneId} />
					</div>
				)}
			</div>
		</div>
	)
}
